/**
 * Slider Component
 *
 * @file slider.js
 */

import $ from "jquery";
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel]);

import 'swiper/swiper-bundle.css';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    const homeSlide = new Swiper('.main-slide', {
      effect: 'fade', 
      fadeEffect: {
        crossFade: true
      },
      speed: 1500,
      loop: false,
      navigation: {
        nextEl: ".main-slide-next",
        prevEl: ".main-slide-prev",
      }
    });
  };
  
  const homeNumberCarousel = () => {
    var homeNumberCarousel = new Swiper('.number-value-item', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 4.2,
      spaceBetween: 25,
      loop:false,
      navigation: {
        nextEl: ".number-sl-next",
        prevEl: ".number-sl-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3.04,
          spaceBetween: 25,
        },
        1380: {
          slidesPerView: 3.5,
          spaceBetween: 25,
        },
        1480: {
          slidesPerView: 4.2,
          spaceBetween: 25,
        },
      },
    });
  };
  
  const homeMobileMapCarousel = () => {
    var homeMobileMapCarousel = new Swiper('.mobile-map-list', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 1.2,
      spaceBetween: 10,
      loop:false,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: ".mb-map-sl-next",
        prevEl: ".mb-map-sl-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
      },
    });
  };
  
  const homeJobCarousel = () => {
    var homeJobCarousel = new Swiper('.job-value-item-carousel', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 4.3,
      spaceBetween: 15,
      loop:false,
      navigation: {
        nextEl: ".job-sl-next",
        prevEl: ".job-sl-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 15,
        },
        1380: {
          slidesPerView: 4.1,
          spaceBetween: 15,
        },
        1480: {
          slidesPerView: 4.3,
          spaceBetween: 15,
        },
      },
    });
  };
  
  const homecompanyCarousel = () => {
    var homecompanyCarousel = new Swiper('.group-company-value-item', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 4.3,
      spaceBetween: 40,
      loop:false,
      navigation: {
        nextEl: ".company-sl-next",
        prevEl: ".company-sl-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3.04,
          spaceBetween: 25,
        },
        1380: {
          slidesPerView: 3.5,
          spaceBetween: 25,
        },
        1480: {
          slidesPerView: 4.3,
          spaceBetween: 40,
        },
      },
    });
  };
  
  const videoMainCarousel = () => {
    var videoThumbCarousel = new Swiper('.video-container-thumb-slide', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 10,
      spaceBetween: 8,
      loop:false,      
      freeMode: true,
      breakpoints: {
        0: {
          slidesPerView: 4,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 6,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 8,
          spaceBetween: 8,
        },
        1200: {
          slidesPerView: 10,
          spaceBetween: 8,
        },
      },
    });
    var videoMainCarousel = new Swiper('.video-container-main-slide', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 1,
      spaceBetween: 0,
      loop:false,
      effect: 'fade', 
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: videoThumbCarousel,
      },
      on: {
        init: function() {
          if($("video-container-main-slide .swiper-slide").length <= 1) {
            $(".video-container-thumb-slide").hide();
          }
        }
      }
    });
  };
  
  const historyCarousel = () => {
    const historyTextCarousel = new Swiper('.history-text-carousel', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 1.3,
      spaceBetween: 0,
      loop: false,
      watchSlidesProgress: true,
      allowTouchMove: true,
      speed:1200,
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 1.2,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 1.3,
          spaceBetween: 0,
        },
      },
    });
    historyTextCarousel.on('slideChange', function () {
      // console.log(this.realIndex);
      historyNumberCarousel.slideTo(this.realIndex)
    });
    var historyNumberCarousel = new Swiper('.history-number-carousel', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: "auto",
      spaceBetween: 40,
      speed:1200,
      loop:false,
      centeredSlides: true,
      slideToClickedSlide: true,
      navigation: {
        nextEl: ".history-sl-next",
        prevEl: ".history-sl-prev",
      },
      thumbs: {
        swiper: historyTextCarousel,
      },
    });
  };
  
  const privilegesCarousel = () => {
    const privilegesCarousel = new Swiper('.privileges-carousel ', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 4,
      spaceBetween: 35,
      loop:false,
      navigation: {
        nextEl: ".privileges-sl-next",
        prevEl: ".privileges-sl-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
        1380: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
        1480: {
          slidesPerView: 4,
          spaceBetween: 35,
        },
      },
    });
  };
  
  const galleryCarousel = () => {
    const galleryCarousel = new Swiper('.gallery-carousel ', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 4,
      spaceBetween: 40,
      loop:false,
      centerMode:true,
      navigation: {
        nextEl: ".gallery-sl-next",
        prevEl: ".gallery-sl-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3.04,
          spaceBetween: 25,
        },
        1380: {
          slidesPerView: 3.5,
          spaceBetween: 25,
        },
        1480: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    });
    const galleryCarouselv3 = new Swiper('.gallery-carousel-w3 ', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 3.1,
      spaceBetween: 40,
      loop:false,
      centerMode:true,
      navigation: {
        nextEl: ".gallery-v3-sl-next",
        prevEl: ".gallery-v3-sl-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3.04,
          spaceBetween: 25,
        },
        1380: {
          slidesPerView: 3.5,
          spaceBetween: 25,
        },
        1480: {
          slidesPerView: 3.1,
          spaceBetween: 40,
        },
      },
    });
  };
  
  const jobVideoCarousel = () => {
    const jobVideoCarousel1 = new Swiper('.job-value-video-carousel-1 ', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 3.1,
      spaceBetween: 20,
      loop:false,
      navigation: {
        nextEl: ".job-video-sl-next1",
        prevEl: ".job-video-sl-prev1",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3.04,
          spaceBetween: 25,
        },
        1380: {
          slidesPerView: 3.5,
          spaceBetween: 25,
        },
        1480: {
          slidesPerView: 3.1,
          spaceBetween: 20,
        },
      },
    });
    const jobVideoCarousel2 = new Swiper('.job-value-video-carousel-2 ', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 3.1,
      spaceBetween: 20,
      loop:false,
      navigation: {
        nextEl: ".job-video-sl-next2",
        prevEl: ".job-video-sl-prev2",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3.04,
          spaceBetween: 25,
        },
        1380: {
          slidesPerView: 3.5,
          spaceBetween: 25,
        },
        1480: {
          slidesPerView: 3.1,
          spaceBetween: 20,
        },
      },
    });
  };

  const otherNewsCarousel = () => {
    const otherNewsCarousel = new Swiper('.other-news-carousel', {
      // direction: 'horizontal',
      // mousewheel: {
			// 	releaseOnEdges: true,
			// },
			// touchReleaseOnEdges: true,
      slidesPerView: 3,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false, 
      },
      navigation: {
        nextEl: ".oth-sl-next",
        prevEl: ".oth-sl-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  };

  const init = () => {
    fullSlider();
    homeNumberCarousel();
    homeMobileMapCarousel();
    homeJobCarousel();
    homecompanyCarousel();
    videoMainCarousel();
    historyCarousel();
    privilegesCarousel();
    galleryCarousel();
    jobVideoCarousel();
    otherNewsCarousel();
  };

  return {
    init,
  };
})();

export default slider;
